<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div class="page-header-title d-flex align-items-center" header-title>
    <span [innerText]="currentMachineGroupName" [title]="currentMachineGroupName" class="h3"></span>
    <div class="page-header-counts">
      <div class="count">
        <span [innerText]="machineCount" class="badge badge-pill badge-primary"></span>
        <span class="count-label" translate>Machines</span>
      </div>
    </div>
  </div>
  <ng-template #filterElement>
    <div class="d-flex align-items-center gap-2">

      @if (layout === dashboardLayouts.LIST) {
        <div class="machine-category-dropdown d-inline-block" ngbDropdown>
          <button
              class="btn btn-outline-primary"
              id="dashboardMachineCategory"
              [attr.aria-label]="'Select machine category' | translate"
              ngbDropdownToggle
              type="button">
            @if (selectedMachineCategoryIcon) {
              <img [src]="selectedMachineCategoryIcon" alt="" class="dashboard-dropdown-icon me-1"/>
            } @else {
              <span class="fa-solid fa-layer-group me-1" aria-hidden="true"></span>
            }
            <span [innerText]="selectedMachineCategoryConfig?.categoryDisplayName || (categoriesAggregate.size > 0 ? ('Machine category' | translate) : ('No machine categories available' | translate))"></span>
          </button>
          <div aria-labelledby="dashboardMachineCategory" ngbDropdownMenu>
            <h6 class="dropdown-header" translate>Machine categories</h6>
            @if (categoriesAggregate.size === 0) {
              <button class="text-muted" disabled ngbDropdownItem type="button">
                <span class="fa-solid fa-circle-info me-1" aria-hidden="true"></span>
                <span translate>No machine categories available</span>
              </button>
            } @else {
              @for (category of categoriesAggregate | keyvalue; track category.key) {
              <button
                  (click)="onMachineCategorySelect(category.key)"
                  [class.active]="selectedMachineCategoryName === category.key"
                  ngbDropdownItem
                  type="button">
                <div class="d-flex align-items-center justify-content-between gap-3">
                  <span class="d-flex align-items-center min-width-0">
                    @if (category.value.categoryIcon) {
                      <img [src]="category.value.categoryIcon" alt="" class="dashboard-dropdown-icon me-1"/>
                    }
                    <span class="text-truncate" [innerText]="category.value.categoryDisplayName || category.key"></span>
                  </span>
                  <span class="badge badge-pill badge-primary" [innerText]="category.value.machinesCount || 0"></span>
                </div>
              </button>
              }
            }
          </div>
        </div>

        <div class="machine-group-dropdown d-inline-block" ngbDropdown>
          <button
              class="btn btn-outline-primary"
              id="dashboardMachineGroup"
              [attr.aria-label]="'Select machine group' | translate"
              ngbDropdownToggle
              type="button">
            <span class="fa-solid fa-folder me-1" aria-hidden="true"></span>
            <span [innerText]="currentMachineGroupName || ('Select machine group' | translate)"></span>
          </button>
          <div aria-labelledby="dashboardMachineGroup" ngbDropdownMenu>
            <h6 class="dropdown-header" translate>Machine groups</h6>
            @if (allChildGroups.length === 0) {
              <button class="text-muted" disabled ngbDropdownItem type="button">
                <span translate>No subgroups available</span>
              </button>
            } @else {
              @for (group of allChildGroups; track group.groupId) {
                <button
                    (click)="onMachineGroupChange(group)"
                    [class.active]="isCurrentMachineGroup(group.groupId)"
                    ngbDropdownItem
                    type="button">
                  <div class="machine-group-option">
                    <span class="d-block fw-semibold text-truncate" [innerText]="group.name"></span>
                    <div class="machine-group-counts d-flex align-items-center gap-4 mt-1 small text-muted">
                      <span class="d-inline-flex align-items-center gap-1">
                        <span class="fa-solid fa-industry" aria-hidden="true"></span>
                        @if (group.machinesCount < 0) {
                          <span class="fa-solid fa-spinner fa-spin" aria-hidden="true"></span>
                        } @else {
                          <span class="fw-semibold" [innerText]="group.machinesCount"></span>
                        }
                        <span translate>Machines</span>
                      </span>
                      <span class="d-inline-flex align-items-center gap-1">
                        <span class="fa-solid fa-folder-tree" aria-hidden="true"></span>
                        @if (group.groupsCount < 0) {
                          <span class="fa-solid fa-spinner fa-spin" aria-hidden="true"></span>
                        } @else {
                          <span class="fw-semibold" [innerText]="group.groupsCount"></span>
                        }
                        <span translate>Subgroups</span>
                      </span>
                    </div>
                  </div>
                </button>
              }
            }
          </div>
        </div>
      }
      <scitis-dashboard-locations
          (locationChanged)="onLocationChange($event)"
          [locationsAggregate]="locationsAggregate"
          [machineCount]="machineCount">
      </scitis-dashboard-locations>
    </div>
  </ng-template>
  <ng-template #filterElement>
    <div class="btn-group" role="group">
      <input type="radio" class="btn-check" name="dashboardLayout" id="dashboardLayoutTile" autocomplete="off"
             [checked]="layout === dashboardLayouts.TILE"
             (click)="selectLayout(dashboardLayouts.TILE)">
      <label class="btn btn-outline-primary" for="dashboardLayoutTile">
        <span class="fa-solid fa-table-cells"></span>
        <span translate>Tiles</span>
      </label>
      <input type="radio" class="btn-check" name="dashboardLayout" id="dashboardLayoutList" autocomplete="off"
             [checked]="layout === dashboardLayouts.LIST"
             (click)="selectLayout(dashboardLayouts.LIST)">
      <label class="btn btn-outline-primary" for="dashboardLayoutList">
        <i class="fa-solid fa-list"></i>
        <span translate>List</span>
      </label>
      <input type="radio" class="btn-check" name="dashboardLayout" id="dashboardLayoutMap" autocomplete="off"
             [checked]="layout === dashboardLayouts.MAP"
             (click)="selectLayout(dashboardLayouts.MAP)">
      <label class="btn btn-outline-primary" for="dashboardLayoutMap">
        <i class="fa-solid fa-map-location-dot"></i>
        <span translate>Map</span>
      </label>
    </div>
  </ng-template>
</scitis-app-global-page-header>

<div *ngIf="!liveDataStreamingEnabled"
     class="alert alert-info text-center">
  <span translate>Live data streaming is disabled. No data is polled.</span>
</div>
<scitis-dashboard-group
    *ngIf="layout === dashboardLayouts.TILE"
    (loadMoreMachineGroupsDataForStatusPage)="loadMoreMachineGroupsDataForStatusPage()"
    [groups]="allChildGroups"
    [parentGroup]="allChildGroups[0]">
</scitis-dashboard-group>

<scitis-machine-tile-container
    [availableMachineCategories]="availableMachineCategories"
    [currentLocation]="location"
    [currentMachineGroupId]="currentMachineGroupId"
    [dashboardLayout]="layout"
    [isWindowContentVisible]="isWindowContentVisible"
    [machineCount]="machineCount"
    [user]="user">

</scitis-machine-tile-container>

<scitis-machine-list-container
    [categoriesAggregate]="categoriesAggregate"
    [currentLocation]="location"
    [currentMachineGroupId]="currentMachineGroupId"
    [dashboardLayout]="layout"
    [isWindowContentVisible]="isWindowContentVisible"
    [user]="user"
    (activeCategoryChange)="onMachineCategoryChanged($event)">

</scitis-machine-list-container>

<scitis-machine-map *ngIf="user && layout === dashboardLayouts.MAP"
                    [groupId]="currentMachineGroupId || (user.machineGroup ? user.machineGroup.toString() : '')"
                    [currentLocation]="location"
                    [user]="user">

</scitis-machine-map>
